import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
// import store from "../../../../../../store";
// import * as uuid from "uuid";
// import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";
// import {HingesModel} from "../models/HingesModel";
import workspace from "../../core/workspace";
import store from "../../../../../../store";
import {setResourceControllerCounter} from "../../../../../../actions/sqftResourceFunctions";

export class HingesController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.hinge;
  }

  // addHingesToTheShape(shape) {
  //   const reduxState = store.getState();
  //   const selectedFeature = reduxState.sqftResourceState.selectedFeature
  //   this.addResource(new HingesModel(
  //     shape.id,
  //     selectedFeature.part.dbFeature.id,
  //     getQtCatName(),
  //     uuid.v4(),
  //     selectedFeature.part.partId,
  //     1)
  //   );
  // }

  updateResourcesId(featureId, partId) {
    const resources = this.getResources();
    for (const resource of resources) {
      if (resource.partId === partId) {
        resource.featureId = featureId
      }
    }
  }

  changeFeatureForTheShape(shapeId, featureId) {
    const resources = this.getAllResourcesForTheShape(shapeId);
    for (const resource of resources) {
      resource.featureId = featureId
    }
  }

  getAllResourcesForTheShape(shapeId) {
    return workspace[this.resourceName].filter((resource) => resource.shapeId === shapeId);
  }

  deleteAllResourcesForTheShape(shapeId) {
    workspace[this.resourceName] = workspace[this.resourceName].filter(
      (resource) => resource.shapeId !== shapeId
    );
  }

  updateReduxCounterOnChange = () => {
    const reduxState = store.getState();
    const counter = reduxState.sqftResourceState.resourceControllerCounter
    store.dispatch(setResourceControllerCounter(counter + 1));
  }
}

